import suspension from './views/suspension'
import plugin from './common/plugin'
import attend from './common/attend'
import { noop } from './utils/'
import Vue from './utils/Vue'

interface ShapConfig {
  mode?: string
  formatter?: () => string
  feedback?: string
  leadin?: string
  hash?: boolean
  absence?: () => boolean | RegExp
}

interface VmOptions {
  el: string | HTMLElement
  options: ShapConfig
  api: any
}

export default function ({ el, api, options }: VmOptions) {
  const { mode, formatter, hash = false, leadin, feedback, absence } = options

  api.plugin(plugin.bind(null, formatter, hash))

  return new Vue({
    el,

    data: {
      deviation: '',
      spreading: false,
      voted: false,

      previewScore: 0,
      score: 0,
      tooltip: {
        visible: false,
        left: 0
      },

      mode: mode || 'inline',
      leadin: leadin || '这个页面有帮助吗？',
      feedback: feedback || '感谢您的反馈！'
    },

    methods: {
      toggleFeedbackPanel () {
        this.spreading = !this.spreading
      },

      sendDocFeedback (vote: number) {
        api.post('doc', { vote })
          .then(() => {
            this.voted = true
            setTimeout(() => { this.spreading = false }, 1000)
          }, noop)
      }
    },

    render (h: any): any {
      if (absence != null && attend(absence)) return
      return suspension.call(this, h)
    },

    created () {
      api.post('pv').then(noop, noop)
    }
  })
}
